import { render, staticRenderFns } from "./SwitchCarrierMethod.vue?vue&type=template&id=380a6876&"
import script from "./SwitchCarrierMethod.vue?vue&type=script&lang=js&"
export * from "./SwitchCarrierMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports